import React from "react";

interface Props {
  onClick: () => void;
  label: string;
  description?: string;
  className?: string;
}

const UserMenuItem: React.FC<Props> = (props): React.ReactElement => {
  return (
    <div
      onClick={props.onClick}
      className={`cursor-pointer ${props.className ?? ""}`}
    >
      <div
        className="overflow-hidden text-[15px]/[24px] font-semibold tracking-[-0.15px] overflow-ellipsis whitespace-nowrap"
        title={props.label}
      >
        {props.label}
      </div>
      {props.description && (
        <div
          className="overflow-hidden text-[13px]/[20px] font-medium tracking-[-0.13px] overflow-ellipsis whitespace-nowrap text-[#9B9DA1]"
          title={props.description}
        >
          {props.description}
        </div>
      )}
    </div>
  );
};

export default UserMenuItem;
